import React from 'react';
import OurValues from '../../../react4xp/components/OurValues'

function OurValuesPart({ bottomBackgroundColor, contentBlocks, imageSrc, imageSrcMedium, intro, isTransparent, mediaCaption, tag, title, youtubeVideoId }) {
	return <OurValues
		tag={tag}
		title={title}
		intro={intro}
		contentBlock={contentBlocks?.map(contentBlock => ({
			img: contentBlock.imageSrc?.link && {
				srcSmall: contentBlock.imageSrcSmall?.link,
				srcMedium: contentBlock.imageSrcMedium?.link,
				src: contentBlock.imageSrc.link,
				alt: contentBlock.imageSrc.alt,
			},
			title: contentBlock.title,
			text: contentBlock.text
		}))}
		image={imageSrc?.link && {
			src: imageSrc.link,
			srcMedium: imageSrcMedium?.link
		}}
		video={youtubeVideoId && {
			type: 'youtube',
			url: youtubeVideoId
		}}
		caption={mediaCaption}
		bgColor={bottomBackgroundColor as "green" | "beige" | "none" | undefined}
	/>
}

export default (props) => <OurValuesPart {...props} />
